import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// تكوين Firebase مع بياناتك الحقيقية
const firebaseConfig = {
  apiKey: "AIzaSyC4Ulge5-YkQuU7W1aUscRlhhUiKBYWonY",
  authDomain: "poultry-1f5cd.firebaseapp.com",
  databaseURL: "https://poultry-1f5cd-default-rtdb.firebaseio.com",
  projectId: "poultry-1f5cd",
  storageBucket: "poultry-1f5cd.firebasestorage.app",
  messagingSenderId: "947000204945",
  appId: "1:947000204945:web:920a941d20901e6b6de930",
};

// تهيئة Firebase
const app = initializeApp(firebaseConfig);

// الحصول على قاعدة البيانات
export const db = getDatabase(app);
